import React from 'react'
import { CardContainer, Shimmer, Footer, CardWrapper } from './style'

function CardShimmer({
  height = '180px',
  width = '100%',
  radius = '12px',
  type = ''
}) {
  let shimmerConfig

  switch (type) {
    case 'superAppTool':
      shimmerConfig = {
        titleWidth: '100%',
        titleHeight: '14px',
        subWidth: '100%',
        subHeight: '14px',
        footer: true,
        maxWidth: '121px',
        minWidth: '96px',
        aspectRatio: '121 / 152'
      }
      break

    case 'aitool':
      shimmerConfig = {
        titleWidth: '90%',
        titleHeight: '32px',
        subWidth: '80%',
        subHeight: '16px',
        footer:false
      }
      break

      case 'galleryCard':
      shimmerConfig = {
        titleWidth: '90%',
        titleHeight: '14px',
        subWidth: '80%',
        subHeight: '14px',
        footer:true
      }
      break

    default:
      shimmerConfig = {
        titleWidth: '80%',
        titleHeight: '27px',
        subWidth: '70%',
        subHeight: '14px',
        footer:true
      }
  }
  return (
    <CardContainer
      width={width}
      height={height}
      radius={radius}
      $maxWidth={shimmerConfig.maxWidth}
      $minWidth={shimmerConfig.minWidth}
      $aspectRatio={shimmerConfig.aspectRatio}
    >
      <CardWrapper>
        <div></div>

       {shimmerConfig.footer && (
         <Footer>
           <Shimmer
             width={shimmerConfig.titleWidth}
             height={shimmerConfig.titleHeight}
             radius="4px"
           />
          <Shimmer
            width={shimmerConfig.subWidth}
            height={shimmerConfig.subHeight}
            radius="4px"
            className="mt-1"
          />
        </Footer>)}
      </CardWrapper>
    </CardContainer>
  )
}

export default CardShimmer
